import { Directive, Input, OnInit, TemplateRef, ViewContainerRef } from "@angular/core";
import jwt_decode from "jwt-decode";

@Directive({
	selector: "[appHasAccess]",
})
export class HasAccessDirective implements OnInit {
	@Input() appHasAccess: string[] = [];

	constructor(
		private templateRef: TemplateRef<any>,
		private viewContainer: ViewContainerRef
	) {}

	ngOnInit() {
		this.initDirective();
	}

	initDirective() {
		let hasAccess = false;
		let permission: string[] = [];
		if (localStorage.getItem("auth-token")) {
			const parseToken: any = jwt_decode(localStorage.getItem("auth-token") ?? "");
			const authorities = parseToken.authorities;

			authorities.forEach((item: any) => {
				permission.push(item.authority);
			});

			for (const permissionValues of this.appHasAccess) {
				if (permission.includes(permissionValues)) {
					hasAccess = true;
					break;
				}
			}

			if (this.appHasAccess.includes("EXEPTION")) {
				this.viewContainer.clear();
			}

			if (hasAccess) {
				this.viewContainer.clear();
				this.viewContainer.createEmbeddedView(this.templateRef);
			} else {
				this.viewContainer.clear();
			}
		} else {
			this.viewContainer.clear();
		}
	}
}
